import { SyncProgressInput } from '@/types/schema';

const FLUSH_INTERVAL = 5 * 1000;

export default class PerformanceBuffer {
  events: Map<string, SyncProgressInput> = new Map();
  onFlush?: (events: SyncProgressInput[]) => void;
  timeoutId: ReturnType<typeof setTimeout>;

  constructor(onFlush: PerformanceBuffer['onFlush']) {
    this.onFlush = onFlush;
    this.timeoutId = setTimeout(this.flush, FLUSH_INTERVAL);
  }

  public enqueue = (newEvent: SyncProgressInput) => {
    const newEventBlockId = newEvent.target?.blockId!;
    const existingEvent = this.events.get(newEventBlockId);

    // update existing event if it contains meta in attrs
    if (existingEvent && existingEvent.attributes?.meta) {
      this.events.set(newEventBlockId, newEvent);
    } else if (
      !existingEvent ||
      existingEvent.attributes?.progress! < newEvent.attributes?.progress!
    ) {
      this.events.set(newEventBlockId, newEvent);
    }
    if (this.events.size >= 100) {
      this.flush();
    }
  };

  public flush = () => {
    if (this.events.size) {
      this.onFlush?.(Array.from(this.events.values()));
      this.events = new Map();
    }

    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(this.flush, FLUSH_INTERVAL);
  };
}
